<template lang="html">
  <div @click="print">
    <slot :class="loadingPrint ? 'is-loading' : null" />
  </div>
</template>

<script>
export default {
  data(){
    return {
      loadingPrint: false
    }
  },

  methods: {
    print(){
      // lazyload all images on the page
      Array.from(window.lazySizes.elements).forEach(el => {
        window.lazySizes.loader.unveil(el)
      })
      setTimeout(() => {
        this.loadingPrint = false
        window.print()
      }, 1000)
    }
  }
}
</script>


<style lang="css">
</style>



// WEBPACK FOOTER //
// shared/components/recipe/Print.vue